<template>
  <div class="container">
    <header-app :title="restaurant.province? restaurant.province.name: ''" class="header-brand" to="listing" :param="{slug: restaurant.province ? restaurant.province.slug : ''}" /> 
    <wrap v-if="loading">
      <div class="row">
          <loading-location />
      </div>
  
    </wrap> 
    <div v-if="loading == false & !restaurant.id" style="padding-top: 200px">
      <div class="text-center">
        <img src="@/assets/icon/icon01.svg"  width="100" alt />
        <h6 class="mt-4">{{ $t("Restaurant_is_not_found") }}</h6>
            <button class="btn btn-brand mt-5" @click="$router.push('/')">
            {{ $t('Get Other')}}
          </button>
      </div>
    </div> 
     
    <wrap v-if="restaurant.id && !loading">
      <base-slider
        :title="restaurant.title"
        :images="restaurant.images"
      ></base-slider>
      <!-- <div
        class="header-detail bg-dark"
        :style="{ 'background-image': 'url(' + restaurant.image + ')' }"
      >
        <div class="mask-content-title">
          <h1 class="mask-content-title-brand">
            {{ restaurant.title }}
          </h1>
        </div>
      </div> -->
      <wrap v-if="(loading === false) & !restaurant.is_open">
        <div class="text-center">
          <img src="@/assets/icon/icon01.svg" class="not_found mb-4" alt />
          <h6>{{ $t("Restaurant_Is_Closed") }}</h6>
        </div>
      </wrap>

      <div v-else class="row btn-order-type mt-3">
        <div
          v-if="restaurant.available_action.take_away === true"
          class="col-md-4 col-sm-12"
        >
          <btn-open-order
            :title="$t('take_away')"
            :memo="$t('take_away_dec')"
            icon="take_away"
            :status="restaurant.available_action.take_away"
            :class="[
              { 'bg-brand': btnState === 'take_away' },
              {
                'btn-disable disabled':
                  restaurant.available_action.take_away == false,
              },
            ]"
            @click.native="
              openMenu('take_away', restaurant.available_action.take_away)
            "
          />
        </div>
        <div
          v-if="restaurant.available_action.delivery === true"
          class="col-md-4 col-sm-12"
        >
          <btn-open-order
            :title="$t('Delivery')"
            :memo="$t('Delivery')"
            icon="delivery"
            :status="restaurant.available_action.delivery"
            :class="[
              { 'bg-brand': btnState === 'delivery' },
              {
                'btn-disable disabled':
                  restaurant.available_action.delivery == false,
              },
            ]"
            @click.native="
              openMenu('delivery', restaurant.available_action.delivery)
            "
          />
        </div>
        <div
          v-if="restaurant.available_action.walk_in === true"
          class="col-md-4 col-sm-12"
        >
          <btn-open-order
            :title="$t('walk_in_guest')"
            :memo="$t('walk_in_guest_desc')"
            icon="walkin"
            :status="restaurant.available_action.walk_in"
            :class="[
              { 'bg-brand': btnState === 'walk_in' },
              {
                'btn-disable disabled':
                  restaurant.available_action.walk_in == false,
              },
            ]"
            @click.native="
              openMenu('walk_in', restaurant.available_action.walk_in)
            "
          />
        </div>
        <div
          v-if="restaurant.available_action.hotel_guest === true"
          class="col-md-4 col-sm-12"
        >
          <btn-open-order
            :title="$t('hotel_guest')"
            :memo="$t('hotel_guest_desc')"
            icon="staying"
            :status="restaurant.available_action.hotel_guest"
            :class="[
              { 'bg-brand': btnState === 'hotel_guest' },
              {
                'btn-disable disabled':
                  restaurant.available_action.hotel_guest == false,
              },
            ]"
            @click.native="
              openMenu('hotel_guest', restaurant.available_action.hotel_guest)
            "
          />
        </div>
      </div>
    </wrap>
     
  </div>
</template>  

<script>
import swal from "sweetalert2";
import i18n from "@/plugins/i18n";
import store from "@/store";
export default {
  layout: "restaurant",
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  // middleware: "redirect_to_restaurant",
  data: () => ({
    enterCodeSelected: false,
    code: "",
    codeLength: 6,
  }),
  computed: {
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
    codeLoading() {
      return store.getters["auth/loading"];
    },
    user() {
      return store.getters["auth/user"];
    },
    codeChecked() {
      return store.getters["auth/codeChecked"];
    },
    place_by_code_activated() {
      return store.getters["auth/place_by_code_activated"];
    },
    btnState() {
      return store.getters["location_selected/btnState"];
    },
    // authcheck() {
    //   return store.getters["auth/check"];
    // },
   
    loading() {
      return store.getters["location/loading"];
    },
    lang() {
      return store.getters["lang/locale"];
    },

    restaurant() {
      return store.getters["location/restaurant"];
    },
    restaurant_selected(){
      return store.getters['location_selected/placeSelected']
    }

  },
  mounted() {
    this.get_restaurant();
  },
  methods: {
    async get_restaurant() {
      var id = this.$route.params.id;
      await store.dispatch("location/get_restaurant", id);
      if (this.restaurant.id) {
        await store.dispatch( "location_selected/setRecentPlace",  this.restaurant );

        let checkDefault = _.find(this.restaurant.currencies, function (el) {
          return el.default === true;
        });
        if (checkDefault) {
          this.$store.dispatch("currency/setCurrency", checkDefault);
        }
      }
    },
    showMenu() {
      this.$store.dispatch("nav/nav_menu");
    },
    async openMenu(id, status) {
      if (!status) return;
      // this.checkToken();
      // let checkAuth = await store.getters["auth/check"];
      // if (this.authcheck) {
 

      let id_ = await store.getters["location_selected/btnState"];
      if (id_ != id || this.restaurant_selected.id != this.restaurant.id) {
        this.$store.dispatch("order/clearOrder");
      }
      
      await store.dispatch("location_selected/setBtnState", id);
      await store.dispatch("location_selected/setLocation", this.restaurant); 

      this.$router.push({ name: "menu" });
      // }
    },
    checkToken() {
      let accessToken = localStorage.access_token;
      if (accessToken) {
        this.$store.dispatch("auth/saveToken", accessToken);
      } else {
        swal
          .fire({
            title: i18n.t("login_required"),
            showClass: {
              popup: "animated fadeInDown faster",
            },
            hideClass: {
              popup: "animated fadeOutUp faster",
            },
            confirmButtonText: i18n.t("login"),
          })
          .then((result) => {
            if (result.value) {
              window.location.href = redirectLogin;
            }
          });
      }
    },

    // async codeLogin() {
    //   let data = {
    //     type_id: this.restaurant.hotel_id,
    //     type: "hotel",
    //     code: this.code
    //   };
    //   await store.dispatch("auth/codeLogin", data);
    //   let isValid = await store.getters["auth/place_by_code_activated"];
    //   if (isValid.type_id) {
    //     this.$store.dispatch("location_selected/setBtnState", 2);
    //     this.$store.dispatch("auth/checkedCode", true);
    //     this.enterCodeSelected = false;
    //     this.code = null;
    //     this.$router.push({ name: "menu" });
    //   }
    // },
    // openEnterCodeForm(id, status) {
    //   if (!status) return;
    //   if (
    //     // this.hotelType === this.place_by_code_activated.type &&
    //     this.restaurant.hotel_id === this.place_by_code_activated.type_id
    //   ) {
    //     // if (this.codeChecked) {

    //     this.openMenu(id, status);
    //     // } else {
    //     //   this.enterCodeSelected = true;
    //     // }
    //   } else {
    //     this.enterCodeSelected = true;
    //   }
    // },
  },
};
</script>